// src/components/Login.js
import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    // Simple hardcoded authentication - in a real app, use an API
    // Use environment variables for credentials if deploying
    const validUsername = process.env.REACT_APP_AUTH_USERNAME || 'admin';
    const validPassword = process.env.REACT_APP_AUTH_PASSWORD || 'password123';

    // Simulate API delay
    setTimeout(() => {
      if (username === validUsername && password === validPassword) {
        // Successful login
        const userData = {
          username,
          name: 'Administrator',
          isAuthenticated: true
        };
        
        // Store user data in localStorage for persistence
        localStorage.setItem('userData', JSON.stringify(userData));
        
        // Call the onLogin callback with user data
        onLogin(userData);
      } else {
        // Failed login
        setError('Invalid username or password');
      }
      setIsLoading(false);
    }, 800);
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={6} lg={5}>
          <Card>
            <Card.Header className="text-center">
              <h4>Strapi Data Cleanup Tool</h4>
              <p className="text-muted mb-0">Login to continue</p>
            </Card.Header>
            <Card.Body>
              {error && <Alert variant="danger">{error}</Alert>}
              
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </Form.Group>

                <div className="d-grid">
                  <Button 
                    variant="primary" 
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" 
                          role="status" aria-hidden="true"></span>
                        Logging in...
                      </>
                    ) : 'Login'}
                  </Button>
                </div>
              </Form>
            </Card.Body>
            <Card.Footer className="text-center text-muted">
              <small>Default credentials: admin / password123</small>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;